import { render, staticRenderFns } from "./addressEdit.vue?vue&type=template&id=67739274&scoped=true&"
import script from "./addressEdit.vue?vue&type=script&lang=js&"
export * from "./addressEdit.vue?vue&type=script&lang=js&"
import style0 from "./addressEdit.vue?vue&type=style&index=0&id=67739274&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67739274",
  null
  
)

export default component.exports